import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=27f0c65c&scoped=true"
var script = {}
import style0 from "./Layout.vue?vue&type=style&index=0&id=27f0c65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0c65c",
  null
  
)

export default component.exports